import { render, staticRenderFns } from "./BaseDistanceEdit.vue?vue&type=template&id=8c21731e&lang=pug"
import script from "./BaseDistanceEdit.vue?vue&type=script&lang=js"
export * from "./BaseDistanceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports